<!-- <div class="mt-auto">
  <div class="flex flex-col gap-2 pb-4">
    <div class="heading_part">
      <h3 class="mb-2 font-medium" i18n>Sign in</h3>
      <p class="text-slate-500" i18n>Welcome back! please enter your credentials</p>
    </div>
  </div>

  <app-messages [messages]="messages" class="mb-4" *ngIf="messages"></app-messages>

  <form [formGroup]="form" (submit)="onLogin()">
    <formly-form [form]="form" [fields]="fields"></formly-form>
    <div class="mb-2 flex justify-end">
      <a routerLink="/account/forgot-password" class="text-sm font-medium" i18n>Forgot Password?</a>
    </div>
    <app-turnstile
      [isTurnstileInPopup]="isTurnstileInPopup"
      (tokenReceived)="onCaptchaVerified($event)"
      (tokenExpired)="onCaptchaExpired()"
    >
    </app-turnstile>
    <div class="flex flex-col gap-y-3 pt-8">
      <button
        [disabled]="!captchaToken && form.invalid"
        type="submit"
        class="btn btn-primary w-full"
        [thkLibProcessing]="!!(loggingIn$ | async)"
        i18n
      >
        Sign in
      </button>
    </div>
  </form>
  <app-firebase-auth></app-firebase-auth>
</div> -->
<div class="min-h-[600px] py-16" id="supertokensui"></div>